import html2pdf from "@vcita/html2pdf.js";
import moment from "moment/moment";

const LANDSCAPE_PRINT_VIEWS = ['month', 'week']
const EVENT_SIZE_BUFFER = 35;
const SCROLL_TOP_BUFFER = EVENT_SIZE_BUFFER * 2;
const HEIGHT_SIZE_BUFFER = EVENT_SIZE_BUFFER * 6;


async function onElementClone(clone, view) {
    //handle timeline headers

    if (view === "month") {
        const dateContainer = clone.getElementsByClassName("smart-scheduler-scrollable-container")[0]
        const cells = dateContainer.getElementsByClassName("smart-scheduler-cell")

        Array.from(cells).filter(cell => {
            return cell.getAttribute('role') === 'gridcell';
        }).forEach((cell) => {
            cell.firstChild.style = `flex: 50%; text-align: right; align-self: baseline;`
        })
        return;
    }

    if (view === "agenda") {
        const timelineHeadersHtmlCollection = clone.getElementsByClassName('timeline-header');
        const timelineHeaders = Array.from(timelineHeadersHtmlCollection);
        timelineHeaders.forEach((header) => {
            header.parentElement.style = 'margin-block-start: 0px;';
        });
        return;
    }

    const timelineHeadersHtmlCollection = clone.getElementsByClassName('timeline-header-time');
    const timelineHeaders = Array.from(timelineHeadersHtmlCollection);
    timelineHeaders.forEach((header) => {
        header.parentElement.style = `
    background-color: transparent;
    margin-top: -10px;
  `;
    });
}

function getCalendarClone(calendar, view) {
    try {
        const oScrollCont = calendar.getElementsByClassName('smart-scheduler-view-container')[0].getElementsByClassName("smart-scheduler-view")[0];
        const oScroll = oScrollCont.scrollTop
        const timelineScale = calendar.getElementsByTagName('smart-scheduler')[0].getAttribute('timeline-day-scale');
        const oId = calendar.getElementsByTagName('smart-scheduler')[0].getAttribute('id');
        calendar.getElementsByTagName('smart-scheduler')[0].setAttribute('timeline-day-scale', 'halfHour');
        const clonedElement = calendar.cloneNode(true);
        const idAddition = '-copy-to-print'
        clonedElement.setAttribute('id', oId + idAddition);
        calendar.getElementsByTagName('smart-scheduler')[0].setAttribute('timeline-day-scale', timelineScale);
        oScrollCont.scrollTop = oScroll;
        clonedElement.style.display = "block";
        clonedElement.classList.add('print-aria')

        if(view === 'month') {
            const day = clonedElement.getElementsByClassName('smart-scheduler-view-all-day')[0];
            day.remove();
            const time = clonedElement.getElementsByClassName('smart-scheduler-view-header-vertical')[0];
            time.remove();
        }

        return clonedElement;
    } catch (e) {
        console.log(e);
    }
}

async function printSchedulerSinglePage(calendar, view, currentDateRange) {
    // preparing elements
    const clonedElement = getCalendarClone(calendar, view);
    if (!clonedElement) return;

    document.body.appendChild(clonedElement);
    try {
        clonedElement.getElementsByTagName('smart-scheduler')[0].setAttribute('view-type', 'week');
        const printElement = clonedElement.getElementsByClassName('smart-scheduler-view-container')[1];

        const eventElementsList = clonedElement.getElementsByClassName('smart-scheduler-event')
        const eventElementsListSorted = [...eventElementsList].filter(a => !a.hasAttribute('all-day')).sort((a, b) => a.offsetTop - b.offsetTop);
        const minTop = eventElementsListSorted[0].offsetTop;
        const maxTop = eventElementsListSorted[eventElementsListSorted.length - 1].offsetTop;
        let height = maxTop - minTop + HEIGHT_SIZE_BUFFER;


        if (view === 'month') {
            height = calendar.getElementsByClassName('smart-scheduler-view-container')[0].clientHeight;
        }

        printElement.style.height = `${height}px`;
        printElement.style.width = `${calendar.clientWidth}px`;

        const printViewElement = printElement.getElementsByClassName("smart-scheduler-view")[0];
        printViewElement.scrollTop = minTop - SCROLL_TOP_BUFFER;

        const format = [printViewElement.clientHeight + 40, printViewElement.clientWidth + 40];
        const orientation = format[0] > format[1] ? 'p' : 'l';

        const startTime = moment(currentDateRange.startTime).format('LL');
        const endTime = moment(currentDateRange.endTime).format('LL');
        const fileName = `Calendar View - ${startTime} - ${endTime}.pdf`;

        const opt = {
            margin: [20, 20, 20, 20],
            filename: fileName,
            html2canvas: {
                scale: 3,
                dpi: 192,
                useCORS: true,
                onclone: (clone) => onElementClone(clone, view),
                logging: false,
            },
            jsPDF: {
                unit: 'px',
                hotfixes: ["px_scaling"],
                orientation: orientation,
                format: format,
            }
        };

        await html2pdf().set(opt).from(printViewElement).save();

        clonedElement.remove();
    } catch (e) {
        clonedElement.remove();
        console.log(e);
    }
}

export default {
    printSchedulerSinglePage
}
